// extracted by mini-css-extract-plugin
export default {"sidePanelBodyWebview":"other-contacts_sidePanelBodyWebview__ijnSB"};